<template>
    <div>
        <div
            class="flex mr-6 mt-4"
            style="justify-content: end"
            @click="removeWebViewFromAndroid"
        >
            <v-icon>mdi-close</v-icon>
        </div>
        <div style="margin: auto; padding: auto" class="flex">
            <div style="flex-direction: column; margin-top: 0vh">
                <div style="transform: translateY(80px)">
                    <img :src="doodleImage" />
                </div>
                <div class="img"><img :src="checkImage" /></div>
            </div>
        </div>
        <div
            class="flex mt-4"
            style="
                flex-direction: column;
                word-wrap: break-word;
                text-align: center;
            "
        >
            <p style="font-weight: 600; font-size: 18px">आपका ऑर्डर सफल हुआ</p>
            <p style="font-weight: 600; font-size: 18px">
                ऑर्डर नंबर : {{ shortId }}
            </p>
            <small style="font-weight: 400; font-size: 18px" class="mr-4 ml-4">
                आप इस पेज को बंद कर सकते हैं।
            </small>

            <small class="mr-4 ml-4" style="font-weight: 400; font-size: 18px">
                हम आपको जल्द ही कॉल करेंगे।ऑर्डर सम्बंधित किसी भी सहायता के लिए
                {{ customerCareNo }} पर कॉल करें।</small
            >
        </div>
    </div>
</template>

<script>
import API_URL from "../../helpers/apiUrls";
import MoengageEventGenerator from '../../helpers/moengageEventGenerator';
import MoengageEvents from '../../helpers/moengageEvents';
export default {
    name: "paymentSuccess",
    data() {
        return {
            doodleImage: require("../../assets/logo/doodle.svg"),
            checkImage: require("../../assets/logo/greenCheck.svg"),
            customerCareNo: null,
            orderId: null,
            shortId:null
        };
    },
    created() {
        this.customerCareNo = process.env.VUE_APP_CUSTOMER_CARE_NO;
        const data = {
            razorpay_payment_id: this.$route.params.payId,
            razorpay_order_id: this.$route.params.orderId,
            success: true,
            razorpay_signature: this.$route.params.sign,
        };
        this.orderId = this.$route.params.orderId;
        this.shortId=sessionStorage.getItem('shortId')
        this.paymentConfirmation(data);
        
    },
    methods: {
        removeWebViewFromAndroid() {
             const moengageAttr={
                            ProductId:sessionStorage.getItem('pid'),
                            ProductName:sessionStorage.getItem('pname'),
                            BrandName:sessionStorage.getItem('brand-name'),
                            BrandId:sessionStorage.getItem('brand-id'),
                            ApiStatus:'',
                            Origin:'Web',
                            Action:'Dismissed'
                }
            MoengageEventGenerator(MoengageEvents.OrderPageAction,moengageAttr);
            this.$gtag.event(MoengageEvents.OrderPageAction,moengageAttr);
            Android.finishWebView();
            
            },
        paymentSuccesOnAndroid() {
          
                Android.paymentSuccess(true);
            
         },

        paymentConfirmation(payload) {
            const successHandler = (response) => {
                if (response.status === 200) {
                    //console.log(response.data);
                    const moengageAttr={
                            ProductId:sessionStorage.getItem('pid'),
                            ProductName:sessionStorage.getItem('pname'),
                            BrandName:sessionStorage.getItem('brand-name'),
                            BrandId:sessionStorage.getItem('brand-id'),
                            ApiStatus:response.status,
                            Origin:'Web',
                            Error:''
                        }
                    MoengageEventGenerator(MoengageEvents.OrderAPIStatus,moengageAttr);
                    this.$gtag.event(MoengageEvents.OrderAPIStatus,moengageAttr);
                    this.paymentSuccesOnAndroid();
                }
            };

            const data = payload;

            const errorHandler = (error) => {
                console.log(error.response);
                const moengageAttr={
                            ProductId:sessionStorage.getItem('pid'),
                            ProductName:sessionStorage.getItem('pname'),
                            BrandName:sessionStorage.getItem('brand-name'),
                            BrandId:sessionStorage.getItem('brand-id'),
                            ApiStatus:error.response.status,
                            Origin:'Web',
                            Error:error.response.status,
                        }
                MoengageEventGenerator(MoengageEvents.OrderAPIStatus,moengageAttr);
                this.$gtag.event(MoengageEvents.OrderAPIStatus,moengageAttr);
                if(error.response.status === 409){
                    this.showToast('Payment verification done already','error',-1,true,'error');
                }else{
                    this.showToast('Temporary Issue', "error",-1,true,'error');
                }
                
            };

            this.requestPOST(
                API_URL.order_payment_confirmation,
                data,
                {},
                successHandler,
                errorHandler
            );
        },
        
    },
};
</script>

<style scoped>
.img {
    margin-left: 3.4rem;
}
</style>